export default __webpack_public_path__ + "static/media/feature-left-3-mobile.5a2ef0c7.png";